import React, { createContext, useContext, useState } from 'react';
import { Currency } from '../types';
import { currencies, getUserCurrency } from '../utils/currency';

interface CurrencyContextType {
  currency: Currency;
  setCurrency: (currency: Currency) => void;
  availableCurrencies: Currency[];
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

export const CurrencyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize currency in useState to prevent double-render from useEffect
  const [currency, setCurrency] = useState<Currency>(() => getUserCurrency());

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, availableCurrencies: currencies }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) throw new Error('useCurrency must be used within a CurrencyProvider');
  return context;
};